import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  getCompleteData,
  getItems,
  getYears,
  searchPart,
} from "../../../pages/Others/Home/OtherHome";
import Axios from "../../../axios/axios";
import { toast } from "react-toastify";
import Select from "react-select";

export const SearchSection = ({ initialFilters = {} }) => {
  const [otherModels, setOtherModels] = useState([]);
  const [otherBrand, setOtherBrand] = useState([]);
  const [otherCategory, setOtherCategory] = useState([]);
  const [region, setRegion] = useState([]);
  const [years, setYears] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);


  const [selectedBrand, setSelectedBrand] = useState(
    initialFilters.brandId || ""
  );
  const [selectedManufacturer, setSelectedManufacturer] = useState(
    initialFilters.manufacturerId || ""
  );
  const [selectedCategory, setSelectedCategory] = useState(
    initialFilters.categoryId && initialFilters.categoryId !== "undefined"
      ? initialFilters.categoryId
      : ""
  );

  const navigate = useNavigate();
  const categoryOptions = otherCategory.map((cat) => ({
    value: cat._id,
    label: cat.name,
  }));
  const brandOptions = otherBrand.map((brand) => ({
    value: brand._id,
    label: brand.name,
    categoryId: brand.categoryId?._id || brand.categoryId
  }));

  // Filter brand options based on selected category
  const filteredBrandOptions = selectedCategory
    ? brandOptions.filter((opt) => String(opt.categoryId) === String(selectedCategory))
    : brandOptions;
  const manufacturerOptions = manufacturers.map((m) => ({
    value: m._id,
    label: m.manufacturerName,
  }));

  useEffect(() => {
    getCompleteData(setOtherModels, setOtherBrand, setOtherCategory);
    getItems(setRegion);
    setYears(getYears());
    fetchManufacturers();
  }, []);

  useEffect(() => {
    if (selectedBrand) getModelData(selectedBrand);
  }, [selectedBrand]);

  const fetchManufacturers = async () => {
    try {
      const res = await Axios.get("/manufacturer");
      setManufacturers(res.data);
    } catch (error) {
      console.error("Failed to fetch manufacturers:", error);
    }
  };

  const getModelData = async (brandId) => {
    if (!brandId) {
      setOtherModels([]);
      return;
    }
    try {
      const res = await Axios.post("/model/modelBybrand", { brand: brandId });
      setOtherModels(res.data);
    } catch (error) {
      console.error(error);
      setOtherModels([]);
    }
  };

  const handleSearch = () => {
    const filters = {
      brandId: selectedBrand || undefined,
      manufacturerId: selectedManufacturer || undefined,
      categoryId: selectedCategory || undefined,
    };

    if (!filters.brandId && !filters.manufacturerId && !filters.categoryId) {
      toast.warning("Please select at least one filter.", {
        position: "bottom-center",
        autoClose: 5000,
      });
      return;
    }

    const searchParams = new URLSearchParams(filters).toString();

    // 🔍 Find selected category object
    const selectedCatObj = otherCategory.find(cat => cat._id === filters.categoryId);

    if (filters.categoryId && filters.categoryId !== "undefined") {
      // 👉 Check if category has subcategories
      if (selectedCatObj && selectedCatObj.subcategories && selectedCatObj.subcategories.length > 0) {

        // 🚀 Navigate to Subcategory Page
        navigate(`/others/subcategories?${searchParams}`, {
          state: {
            category: selectedCatObj,
            otherCategory,
            otherBrand,
            otherModels,
            region,
            filters,
          },
        });

      } else {
        // 🚀 Normal Flow: Go to products page
        navigate(`/others/products?${searchParams}`);
      }

    } else {
      // Category not selected → stay on page with updated filters
      navigate({
        pathname: "/others/category",
        search: searchParams.toString(),
        filters,
      });
    }
  };

  const style = {
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    fontWeight: 700,
    color: "#353C4B",
  };

  return (
    <section id="banner-building">
      <div className="search-width-div-new">
        <div
          className="banner"
          style={{
            backgroundImage: "url('images/slide1.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container d-flex justify-content-center align-items-center min-vh-100 search-part-section">
            <div className="bnr-div"  >
              <div className="row w-100">
                <div className="col-12 text-center" style={style}>
                  <h1 className="text-uppercase text-center">
                    Find Other Building Materials
                  </h1>
                  <p>
                    Whether you're a professional mechanic , finding the right
                    part for your vehicle has never been easier.
                    <br /> Use our precise search tool to locate the exact spare
                    part you need.
                  </p>
                </div>
              </div>
              <div className="row justify-content-center g-2">
                {/* Category */}
                <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                  <Select
                    className="basic-single w-100"
                    classNamePrefix="select"
                    placeholder="Select Category"
                    value={
                      categoryOptions.find(
                        (opt) => opt.value === selectedCategory
                      ) || null
                    }
                    onChange={(selected) => {
                      setSelectedCategory(selected ? selected.value : "");
                      setSelectedBrand(""); // Reset brand when category changes
                      setOtherModels([]); // Reset models
                    }}
                    options={categoryOptions}
                    // isClearable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        border: "1px solid #ced4da",
                        boxShadow: "none",
                        "&:hover": { borderColor: "#adb5bd" },
                        minHeight: "42px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />
                </div>

                {/* Brand */}
                <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                  <Select
                    className="basic-single w-100"
                    classNamePrefix="select"
                    placeholder="Select Brand"
                    value={
                      brandOptions.find((opt) => opt.value === selectedBrand) ||
                      null
                    }
                    onChange={(selected) =>
                      setSelectedBrand(selected ? selected.value : "")
                    }
                    options={filteredBrandOptions}
                    // isClearable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        border: "1px solid #ced4da",
                        boxShadow: "none",
                        "&:hover": { borderColor: "#adb5bd" },
                        minHeight: "42px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />
                </div>

                {/* Manufacturer */}
                <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                  <Select
                    className="basic-single w-100"
                    classNamePrefix="select"
                    placeholder=" Manufacturer"
                    value={
                      manufacturerOptions.find(
                        (opt) => opt.value === selectedManufacturer
                      ) || null
                    }
                    onChange={(selected) =>
                      setSelectedManufacturer(selected ? selected.value : "")
                    }
                    options={manufacturerOptions}
                    // isClearable
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        border: "1px solid #ced4da",
                        boxShadow: "none",
                        "&:hover": { borderColor: "#adb5bd" },
                        minHeight: "42px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />
                </div>

                {/* Search Button */}
                <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                  <button
                    type="button"
                    className="form-control w-100 text-white"
                    style={{
                      backgroundColor: "#db0505ff",
                      borderRadius: "0.25rem",
                      border: "5px solid #db0505ff",
                    }}
                    onClick={handleSearch}
                  >
                    <i className="fa fa-search" aria-hidden="true"></i>
                    &nbsp;&nbsp;Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
